import React from "react";

const BackgroundImage = () => {
  return (
    <img
      style={{ height: "100%", width: "100%", objectFit: "cover" }}
      src="https://source.unsplash.com/featured/?nature,hiking,forest"
      alt="background image"
    />
  );
};
export default BackgroundImage;
